<template>
  <!-- *** PAGE NOT USED! *** -->
  <v-container fluid class="monitorSite">
    <v-row class="justify-center align-baseline">
      <v-btn normal class="blue-button mr-12" @click="back">
        <v-icon>mdi-arrow-left</v-icon>Back
      </v-btn>
      <h1 class="mb-3">Data Collection Status = /STATUS/</h1>
    </v-row>
    <v-layout data-app wrap row>
      <v-flex xs12>
        <ag-grid-vue
          style="width: 820px; height: 700px;"
          class="ag-theme-balham center-box elevation-2"
          :columnDefs="columnDefs"
          :rowData="rowData"
          @rowDoubleClicked="onRowDoubleClicked"
        ></ag-grid-vue>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import router from "@/router";
import { CONSTANTS } from "@/common/constants";
import { AgGridVue } from "ag-grid-vue";
import { adminDataCollectionService } from "@/services/adminDataCollectionService.js";

export default {
  name: "AdminDataCollectionView",
  components: {
    AgGridVue
  },
  data: () => ({
    id: 0,
    type: 0,
    columnDefs: [],
    rowData: [],
    reportHeaders: [
      { headerName: "AGENCY DATA", field: "officeData", width: 400, sortable: true },
      { headerName: "Number", field: "number", sortable: true },
      { headerName: "Percentage", field: "percentage", sortable: true }
    ],
    officeHeaders: [
      { headerName: "Agency Name", field: "officeName", width: 400, sortable: true },
      { headerName: "Department", field: "department", sortable: true },
      { headerName: "Final Submission", field: "finalSubmission", sortable: true }
    ],
    showOffices: true
  }),
  methods: {
    onRowDoubleClicked (evt) {
      let me = this;
      if (this.showOffices) {
        adminDataCollectionService
          .getDataCollectionStatsReportForOffice(me.type)
          .then(function (resp) {
            me.columnDefs = me.reportHeaders;
            me.rowData = resp.data;
            me.showOffices = false;
          })
          .catch(function (err) {
            me.rowData = [];
            let e = err;
          });
      } else {
        adminDataCollectionService
          .getDataCollectionStatsReportForSuboffices(evt.data.officeId, me.type)
          .then(function (resp) {
            me.columnDefs = me.officeHeaders;
            me.rowData = resp.data;
            me.showOffices = true;
          })
          .catch(function (err) {
            me.rowData = [];
            let e = err;
          });
      }
    },

    back () {
      // console.log(JSON.stringify(this.$router.go(-1)));
      this.$router.go(-1);
      this.$router.push({ name: "home" });
    }
  },
  mounted () {
    if (this.$route.params.type || this.$route.params.type === 0) this.type = this.$route.params.type;
    if (this.$route.params.id || this.$route.params.id === 0) this.id = this.$route.params.id;

    if (this.type || this.type === 0) {
      let me = this;
      adminDataCollectionService
        .getDataCollectionStatsForReport(this.type)
        .then(function (resp) {
          me.rowData = resp.data;
        })
        .catch(function (err) {
          let e = err;
        });
    }

    this.columnDefs = this.officeHeaders;
  }
};
</script>

<style scoped>
</style>
